import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import { EvtHeader, EvtSectionHeader } from "components/header";
import { GITHUB, DISCORD } from "icons";
import ProfileIntegrationCard from 'components/profile/integrations/display-card';

export default function MyProfileIntegrations() {
    const user = useSelector(selectUser);

    const integrations = [
        {
            id: 'github',
            name: 'GitHub',
            description: 'When connected, PC/JC can add you to the right repo.',
            icon: GITHUB,
            userId: user.id,
            link: `https://github.com/${user.github_username}`
        },
        {
            id: 'discord',
            name: 'Discord',
            description: 'When connected, PC/JC can add you to the right channel.',
            icon: DISCORD,
            userId: user.id,
            link: `https://discord.com/users/${user.discord_user_id}`
        }
    ];

    const handleConnect = async (integrationId) => {
        try {
            if (integrationId === 'github') {
                const clientId = import.meta.env.VITE_GITHUB_CLIENT_ID;
                const redirect_url = `https://everest.7span.work/profile/integrations/callback`;
                const authorizeUrl = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${redirect_url}&state=github`;
                window.location.assign(authorizeUrl);
            }
            if (integrationId === 'discord') {
                const clientId = import.meta.env.VITE_DISCORD_CLIENT_ID;
                const redirect_url = `https://everest.7span.work/profile/integrations/callback`;
                const authorizeUrl = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirect_url}&scope=identify&state=discord`;
                window.location.assign(authorizeUrl);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const isIntegrationConnected = (integration) => {
        if (!user) return false;
        if (integration.id === 'github') return Boolean(user.github_username);
        if (integration.id === 'discord') return Boolean(user.discord_user_id);
        return false;
    };

    const connectedIntegrations = integrations.filter((integration) => isIntegrationConnected(integration));
    const disconnectedIntegrations = integrations.filter((integration) => !isIntegrationConnected(integration));

    return (
        <div className="flex-1">
            <div >
                <div>
                    <EvtHeader title="Integrations" />
                </div>
                <section>
                    {connectedIntegrations.length > 0 && (
                        <div className="p-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                            {connectedIntegrations.map((integration) => (
                                <ProfileIntegrationCard
                                    key={integration.id}
                                    icon={integration.icon}
                                    title={integration.name}
                                    description={`Your ${integration.name} account is successfully connected and syncing.`}
                                    isConnected
                                    link={integration.link}
                                />
                            ))}
                        </div>
                    )}
                    {disconnectedIntegrations.length > 0 && (
                        <div>
                            <EvtSectionHeader title="Available Integrations" className="!pt-0" />
                            <div className="p-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                                {disconnectedIntegrations.map((integration) => (
                                    <ProfileIntegrationCard
                                        key={integration.id}
                                        icon={integration.icon}
                                        title={integration.name}
                                        description={integration.description}
                                        isConnected={false}
                                        onConnect={() => handleConnect(integration.id)}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
}
